/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
const findIndex=function(n,t,e){let r=-1,f=n?n.length:0;for(t=t||function(n){return n};++r<f;)if(t.call(e,n[r],r,n))return r;return-1};export default findIndex;